import ellieAvatar from "@/assets/ellie-avatar.jpg";

// Ellie's avatar with a slow, luminous gradient ring.
export const EllieOrb = ({ size = 40, testId = "ellie-orb" }) => (
  <span className="fio-orb-ring inline-flex shrink-0 rounded-full" style={{ width: size, height: size }} data-testid={testId}>
    <img src={ellieAvatar} alt="Ellie" width={size} height={size}
      className="h-full w-full rounded-full border-2 border-white object-cover" />
  </span>
);

export const Ambient = () => (
  <div className="fio-ambient" aria-hidden><span /><i /></div>
);
